interface DirtyInterface {
  formik: Object,
}

export const Dirty = ({formik}: DirtyInterface) => {
  return (
    <></>
    // <Prompt
    //     when={!!formik.dirty && !formik.isValidating}
    //     message={() =>
    //         `Les modifications que vous avez apportées ne seront peut-être pas enregistrées.`
    //     }
    // />
  )
}
